"use strict";
exports.__esModule = true;
exports.toLang = void 0;
var LANG = {
    'fr-fr': 'fr',
    'en-gb': 'en'
};
var toLang = function (prismicLang, logger) { return logger.toConstValue(prismicLang, LANG); };
exports.toLang = toLang;
//# sourceMappingURL=lang.js.map